import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ProjectDetailUI from './ProjectDetailUI.js'

class ProjectDetailSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      addCustomerMode: false
    }
  }

  render() {
    return (
      <ProjectDetailUI
        loan={this.props.loan}
        context={this.props.context}
        customerList={this.props.customerList}
        filteredCustomerList={this.props.filteredCustomerList}
        selectedCustomer={this.props.selectedCustomer}
        onRefreshClick={this.props.onRefreshClick}
        //
        onDownloadPrjFileClick={this.onDownloadPrjFileClick}
        downloadPrjFileErrorList={this.state.downloadPrjFileErrorList}
        downloadPrjFileRequested={this.state.downloadPrjFileRequested}
        //
        addCustomerMode={this.state.addCustomerMode}
        onAddCustomerClick={() => { this.setState({ addCustomerMode: true }) }}
        onAddCustomerCancel={() => { this.setState({ addCustomerMode: false }) }}
        //
        onCreateProjectClick={this.props.onCreateProjectClick}
        //
        onProjectUpdateClick={this.props.onProjectUpdateClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    // this.getBillList(context, this.props.loan)
  }

  componentDidUpdate(prevProps) {
    let loan = this.props.loan
    if (!loan)
      return
    if (prevProps.loan && prevProps.loan.loanId == loan.loanId)
      return
  
    let context = this.props.context
    // this.getBillList(context, this.props.loan)
  }

  onDownloadPrjFileClick = (event) => {
    let projectId = event.currentTarget.getAttribute('data-id')
    this.setState({ downloadPrjFileRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/projects/${projectId}/files/attachment/fileDownloadSignedUrl`,
      this.onDownloadPrjFileClickCallback, null, null
    )
  }

  onDownloadPrjFileClickCallback = (response) => {
    this.setState({
      downloadPrjFileErrorList: response.errorList,
      downloadPrjFileRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export default ProjectDetailSF
